import { render, staticRenderFns } from "./KeyBoardInput.vue?vue&type=template&id=0496f1cb&scoped=true&"
import script from "./KeyBoardInput.vue?vue&type=script&lang=js&"
export * from "./KeyBoardInput.vue?vue&type=script&lang=js&"
import style0 from "./KeyBoardInput.vue?vue&type=style&index=0&id=0496f1cb&lang=less&scoped=true&"
import style1 from "./KeyBoardInput.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496f1cb",
  null
  
)

export default component.exports